/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-11-30 10:57:30
 * @LastEditors: changfeng
 * @LastEditTime: 2024-10-09 11:09:09
 */
import menu from "./en-US/menu";
import nav from "@/language/locales/en-US/nav";
import dashboard from "@/language/locales/en-US/dashboard";
import account from "@/language/locales/en-US/account";
import automatedRules from "@/language/locales/en-US/automatedRules";

import teamSettings from "@/language/locales/en-US/teamSettings";
import subscription from "@/language/locales/en-US/subscription";
import billing from "@/language/locales/en-US/billing";
import tips from "@/language/locales/en-US/tips";
import accountSettings from "@/language/locales/en-US/accountSettings";
import actionButton from "./en-US/actionButton";
import message from "./en-US/message";
import condition from "./en-US/condition";
import optimizationEvent from "./en-US/optimizationEvent";
import language from "./en-US/language";
import common from "./en-US/common";

export default {
	...nav,
	...menu,
	...dashboard,
	...account,
	...automatedRules,

	...teamSettings,
	...subscription,
	...billing,
	...tips,
	...accountSettings,
	...actionButton,
	...message,
	...condition,
	...optimizationEvent,
	...language,
	...common
};
